import {BrowserModule} from '@angular/platform-browser';
import {NgModule, ErrorHandler, APP_INITIALIZER} from '@angular/core';
import * as Sentry from '@sentry/angular';

import {ApiService} from './services/api.service';
import {SweetalertService} from './services/sweetalert.service';
import {AuthService} from './services/auth.service';
import {DateService} from './services/date.service';

import {AppComponent} from './app.component';
import {LoginComponent} from './pages/shared/login/login.component';
import {RegisterComponent} from './pages/shared/register/register.component';
import {AccountRecoveryComponent} from './pages/shared/account-recovery/account-recovery.component';
import {ChangePasswordByRecoveryComponent} from './pages/shared/change-password-by-recovery/change-password-by-recovery.component';
import {LoaderComponent} from './components/shared/loader/loader.component';

import {AppRoutingModule} from './app-routing.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {HttpClientModule} from '@angular/common/http';
import {ReactiveFormsModule} from '@angular/forms';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSliderModule} from '@angular/material/slider';
import {MatIconModule} from '@angular/material/icon';
import {GuardService} from './services/guard.service';
import {AdminModule} from './pages/admin/admin.module';
import {PublisherModule} from './pages/publisher/publisher.module';
import {Router} from '@angular/router';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {ErrorService} from './services/error.service';
import {RwdService} from './services/rwd.service';
import {RulesComponent} from './pages/shared/rules/rules.component';
import {RulesUsudeComponent} from './pages/shared/rules-usude/rules-usude.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    AccountRecoveryComponent,
    RulesComponent,
    RulesUsudeComponent,
    LoaderComponent,
    ChangePasswordByRecoveryComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    MatIconModule,
    AdminModule,
    PublisherModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
      showDialog: true,
    }),
    },
    {
      provide: Sentry.TraceService,
        deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
        useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    ApiService,
    SweetalertService,
    ErrorService,
    AuthService,
    DateService,
    GuardService,
    RwdService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
